<script setup>

import { inject } from 'vue';
import Tag from 'primevue/tag';

const { jeuDonnees } = defineProps({
    jeuDonnees: Object
});

const getParametre = inject('getParametre');

</script>

<template>
    <Tag class="badge campagne">
        {{ jeuDonnees.campagne }}
    </Tag>
    <Tag v-for="hypothese in jeuDonnees.hypotheses" 
        class="badge hypothese"
        v-tooltip="getParametre(hypothese.idParametre).libelle">
        {{ hypothese.valeurFormatee }}
    </Tag>
</template>

<style scoped>

.badge {
	border: solid 1px var(--couleur-bordure);
	border-radius: 5px;
	user-select: none;
	padding: 5px 7px;
	font-weight:700 !important;
	font-size: 8px !important;
}

.campagne {
    background-color: rgb(229, 149, 37) !important;
}

.hypothese {
    background-color: rgb(0, 159, 74) !important;
}

</style>